export const COUNTRIES_STP = [
    { id: '187', value: 'MEXICO' },
    { id: '4', value: 'ALTO VOLTA' },
    { id: '7', value: 'ANGUILA' },
    { id: '256', value: 'ANTARTIDA' },
    { id: '137', value: 'ANTIGUA REPUBLICA YUGOSLAVA DE MACEDONIA' },
    { id: '8', value: 'ANTIGUA Y BARBUDA' },
    { id: '9', value: 'ANTILLAS NEERLANDESAS' },
    { id: '15', value: 'ARUBA' },
    { id: '23', value: 'BARBADOS' },
    { id: '26', value: 'BELICE' },
    { id: '27', value: 'BERMUDAS' },
    { id: '28', value: 'BIRMANIA' },
    { id: '30', value: 'BOSNIA HERZEGOVINA' },
    { id: '33', value: 'BRUNEI MALASIA' },
    { id: '238', value: 'BURKINA FASO' },
    { id: '38', value: 'CAMPIONE D ITALIA' },
    { id: '260', value: 'CLIPPERTON' },
    { id: '17', value: 'COMMONWEALTH DE AUSTRALIA' },
    { id: '55', value: 'COMMONWEALTH DE DOMINICA' },
    { id: '20', value: 'COMMONWEALTH DE LAS BAHAMAS' },
    { id: '241', value: 'COMORAS' },
    { id: '210', value: 'CONFEDERACION HELVETICA, SUIZA' },
    { id: '48', value: 'CURAZAO' },
    { id: '53', value: 'DAHOMEY HOY BENIN R.P.' },
    { id: '39', value: 'DOMINIO DE CANADA' },
    { id: '59', value: 'EMIRATOS ARABES UNIDOS' },
    { id: '242', value: 'ERITREA' },
    { id: '116', value: 'ESTADO DE ISRAEL' },
    { id: '61', value: 'ESTADO DE KUWAIT' },
    { id: '154', value: 'ESTADO DE NEPAL' },
    { id: '62', value: 'ESTADO DE QATAR' },
    { id: '173', value: 'ESTADO LIBRE ASOCIADO DE PUERTO RICO' },
    { id: '63', value: 'ESTADOS UNIDOS DE NORTEAMERICA' },
    { id: '192', value: 'FEDERACION RUSA, RUSIA' },
    { id: '244', value: 'FIYI' },
    { id: '71', value: 'GEORGIA' },
    { id: '262', value: 'GEORGIA DEL SUR E ISLAS SANDWICH DEL SUR' },
    { id: '73', value: 'GIBRALTAR' },
    { id: '135', value: 'GRAN DUCADO DE LUXEMBURGO' },
    { id: '74', value: 'GRANADA' },
    { id: '75', value: 'GRECIA' },
    { id: '76', value: 'GROENLANDIA' },
    { id: '261', value: 'GUADALUPE' },
    { id: '77', value: 'GUAM' },
    { id: '78', value: 'GUATEMALA' },
    { id: '79', value: 'GUAYANA FRANCESA' },
    { id: '108', value: 'GUERNESEY' },
    { id: '80', value: 'GUINEA' },
    { id: '81', value: 'GUINEA ECUATORIAL' },
    { id: '82', value: 'GUINEA-BISSAU' },
    { id: '83', value: 'GUYANA' },
    { id: '84', value: 'GUYANA HOLANDESA' },
    { id: '85', value: 'GUYANA INGLESA' },
    { id: '87', value: 'HOLANDA' },
    { id: '89', value: 'HONG KONG' },
    { id: '90', value: 'HUNGRIA' },
    { id: '258', value: 'ISLA BOUVET' },
    { id: '240', value: 'ISLA DE CHRISTMAS' },
    { id: '101', value: 'ISLA DE MAN' },
    { id: '98', value: 'ISLA DE NORFOLK' },
    { id: '99', value: 'ISLA DE PASCUA' },
    { id: '100', value: 'ISLA DE SAN PEDRO Y MIQUELIN' },
    { id: '102', value: 'ISLA QUESHM' },
    { id: '103', value: 'ISLANDIA' },
    { id: '104', value: 'ISLAS AZORES' },
    { id: '97', value: 'ISLAS CAIMAN' },
    { id: '105', value: 'ISLAS CANARIAS' },
    { id: '106', value: 'ISLAS COOK' },
    { id: '16', value: 'ISLAS DE ASCENCION' },
    { id: '107', value: 'ISLAS DE COCOS O KELLING' },
    { id: '243', value: 'ISLAS FAROE' },
    { id: '263', value: 'ISLAS HEARD Y MCDONALD' },
    { id: '109', value: 'ISLAS MALVINAS' },
    { id: '267', value: 'ISLAS MARIANAS DEL NORTE' },
    { id: '272', value: 'ISLAS MENORES ALEJADAS DE LOS ESTADOS UNIDOS' },
    { id: '111', value: 'ISLAS PACIFICO' },
    { id: '169', value: 'ISLAS PITCAIRN' },
    { id: '112', value: 'ISLAS SALOMON' },
    { id: '113', value: 'ISLAS TURCAS Y CAICOS' },
    { id: '114', value: 'ISLAS VIRGENES BRITANICAS' },
    { id: '115', value: 'ISLAS VIRGENES DE ESTADOS UNIDOS DE AMERICA' },
    { id: '257', value: 'ISLAS √ÖLAND' },
    { id: '132', value: 'JAMAHIRIYA ARABE LIBIA POPULAR SOCIALISTA' },
    { id: '118', value: 'JAMAICA' },
    { id: '119', value: 'JAPON' },
    { id: '265', value: 'JERSEY' },
    { id: '126', value: 'LABUAN' },
    { id: '128', value: 'LATVIA' },
    { id: '266', value: 'LETONIA' },
    { id: '139', value: 'MADEIRA' },
    { id: '140', value: 'MALASIA' },
    { id: '245', value: 'MARTINICA' },
    { id: '275', value: 'MAYOTTE' },
    { id: '246', value: 'MICRONESIA' },
    { id: '187', value: 'MÉXICO' },
    { id: '247', value: 'MOLDOVA' },
    { id: '147', value: 'MOLDURA' },
    { id: '149', value: 'MONGOLIA' },
    { id: '248', value: 'MONTENEGRO' },
    { id: '150', value: 'MONTSERRAT' },
    { id: '155', value: 'NEVIS' },
    { id: '268', value: 'NIGER' },
    { id: '159', value: 'NIUE' },
    { id: '160', value: 'NO CLASIFICADO' },
    { id: '249', value: 'NUEVA CALEDONIA' },
    { id: '162', value: 'NUEVA ZELANDA' },
    { id: '269', value: 'PAISES BAJOS' },
    { id: '250', value: 'PALESTINA' },
    { id: '251', value: 'PAPUA NUEVA GUINEA' },
    { id: '170', value: 'POLINESIA FRANCESA' },
    { id: '5', value: 'PRINCIPADO DE ANDORRA' },
    { id: '133', value: 'PRINCIPADO DE LIECHENSTEIN' },
    { id: '148', value: 'PRINCIPADO DE MONACO' },
    { id: '136', value: 'REGION ESPECIAL ADMINIOSTRATIVA DE MACAO DE LA REPUBLICA POPULAR CHINA' },
    { id: '10', value: 'REINO DE ARABIA SAUDITA' },
    { id: '21', value: 'REINO DE BAHREIN' },
    { id: '25', value: 'REINO DE BELGICA' },
    { id: '36', value: 'REINO DE BUTAN' },
    { id: '54', value: 'REINO DE DINAMARCA' },
    { id: '60', value: 'REINO DE ESPAÑA' },
    { id: '129', value: 'REINO DE LESOTHO' },
    { id: '144', value: 'REINO DE MARRUECOS' },
    { id: '161', value: 'REINO DE NORUEGA' },
    { id: '209', value: 'REINO DE SUECIA' },
    { id: '174', value: 'REINO DE SWAZILANDIA' },
    { id: '212', value: 'REINO DE TAILANDIA' },
    { id: '175', value: 'REINO DE TONGA' },
    { id: '120', value: 'REINO HASHEMITA DE JORDANIA' },
    { id: '93', value: 'REINO UNIDO' },
    { id: '57', value: 'REPUBLICA ARABE DE EGIPTO' },
    { id: '202', value: 'REPUBLICA ARABE SIRIA' },
    { id: '13', value: 'REPUBLICA ARGENTINA' },
    { id: '228', value: 'REPUBLICA BOLIVARIANA DE VENEZUELA' },
    { id: '176', value: 'REPUBLICA CENTRO AFRICANA' },
    { id: '50', value: 'REPUBLICA CHECA' },
    { id: '2', value: 'REPUBLICA DE ALBANIA' },
    { id: '6', value: 'REPUBLICA DE ANGOLA' },
    { id: '14', value: 'REPUBLICA DE ARMENIA' },
    { id: '18', value: 'REPUBLICA DE AUSTRIA' },
    { id: '19', value: 'REPUBLICA DE AZERBAIYAN' },
    { id: '24', value: 'REPUBLICA DE BELARUS' },
    { id: '29', value: 'REPUBLICA DE BOLIVIA' },
    { id: '31', value: 'REPUBLICA DE BOTSWANA' },
    { id: '34', value: 'REPUBLICA DE BULGARIA' },
    { id: '35', value: 'REPUBLICA DE BURUNDI' },
    { id: '177', value: 'REPUBLICA DE CABO VERDE' },
    { id: '37', value: 'REPUBLICA DE CAMERUN' },
    { id: '49', value: 'REPUBLICA DE CHAD' },
    { id: '51', value: 'REPUBLICA DE CHILE' },
    { id: '213', value: 'REPUBLICA DE CHINA, TAIWAN' },
    { id: '178', value: 'REPUBLICA DE CHIPRE' },
    { id: '40', value: 'REPUBLICA DE COLOMBIA' },
    { id: '43', value: 'REPUBLICA DE COREA' },
    { id: '44', value: 'REPUBLICA DE COSTA DE MARFIL' },
    { id: '45', value: 'REPUBLICA DE COSTA RICA' },
    { id: '46', value: 'REPUBLICA DE CROACIA' },
    { id: '47', value: 'REPUBLICA DE CUBA' },
    { id: '179', value: 'REPUBLICA DE DJIBOUTI' },
    { id: '58', value: 'REPUBLICA DE EL SALVADOR' },
    { id: '64', value: 'REPUBLICA DE ESTONIA' },
    { id: '67', value: 'REPUBLICA DE FINLANDIA' },
    { id: '68', value: 'REPUBLICA DE FRANCIA' },
    { id: '69', value: 'REPUBLICA DE GABON' },
    { id: '72', value: 'REPUBLICA DE GHANA' },
    { id: '86', value: 'REPUBLICA DE HAITI' },
    { id: '88', value: 'REPUBLICA DE HONDURAS' },
    { id: '91', value: 'REPUBLICA DE INDIA' },
    { id: '92', value: 'REPUBLICA DE INDONESIA' },
    { id: '94', value: 'REPUBLICA DE IRAK' },
    { id: '96', value: 'REPUBLICA DE IRLANDA' },
    { id: '117', value: 'REPUBLICA DE ITALIA' },
    { id: '121', value: 'REPUBLICA DE KAZAJSTAN' },
    { id: '122', value: 'REPUBLICA DE KENYA' },
    { id: '123', value: 'REPUBLICA DE KIRGUISTAN' },
    { id: '124', value: 'REPUBLICA DE KIRIBATI' },
    { id: '70', value: 'REPUBLICA DE LA GAMBIA' },
    { id: '66', value: 'REPUBLICA DE LAS FILIPINAS' },
    { id: '110', value: 'REPUBLICA DE LAS ISLAS MARSHALL' },
    { id: '181', value: 'REPUBLICA DE LAS MALDIVAS' },
    { id: '131', value: 'REPUBLICA DE LIBERIA' },
    { id: '134', value: 'REPUBLICA DE LITUANIA' },
    { id: '138', value: 'REPUBLICA DE MADAGASCAR' },
    { id: '141', value: 'REPUBLICA DE MALAWI' },
    { id: '142', value: 'REPUBLICA DE MALI' },
    { id: '143', value: 'REPUBLICA DE MALTA' },
    { id: '145', value: 'REPUBLICA DE MAURICIO' },
    { id: '151', value: 'REPUBLICA DE MOZAMBIQUE' },
    { id: '152', value: 'REPUBLICA DE NAMIBIA' },
    { id: '153', value: 'REPUBLICA DE NAURU' },
    { id: '156', value: 'REPUBLICA DE NICARAGUA' },
    { id: '164', value: 'REPUBLICA DE PALAOS' },
    { id: '167', value: 'REPUBLICA DE PARAGUAY' },
    { id: '171', value: 'REPUBLICA DE POLONIA' },
    { id: '172', value: 'REPUBLICA DE PORTUGAL' },
    { id: '190', value: 'REPUBLICA DE RUANDA' },
    { id: '199', value: 'REPUBLICA DE SENEGAL' },
    { id: '182', value: 'REPUBLICA DE SEYCHELLES' },
    { id: '201', value: 'REPUBLICA DE SIERRA LEONA' },
    { id: '236', value: 'REPUBLICA DE SINGAPURE' },
    { id: '207', value: 'REPUBLICA DE SUDAFRICA' },
    { id: '211', value: 'REPUBLICA DE SURINAM' },
    { id: '215', value: 'REPUBLICA DE TAJIKISTAN' },
    { id: '216', value: 'REPUBLICA DE TOGO' },
    { id: '219', value: 'REPUBLICA DE TRINIDAD Y TOBAGO' },
    { id: '183', value: 'REPUBLICA DE TUNEZ' },
    { id: '223', value: 'REPUBLICA DE TURQUIA' },
    { id: '227', value: 'REPUBLICA DE UZBEKISTAN' },
    { id: '184', value: 'REPUBLICA DE VANUATU' },
    { id: '231', value: 'REPUBLICA DE ZAIRE' },
    { id: '232', value: 'REPUBLICA DE ZAMBIA' },
    { id: '41', value: 'REPUBLICA DEL CONGO' },
    { id: '56', value: 'REPUBLICA DEL ECUADOR' },
    { id: '130', value: 'REPUBLICA DEL LIBANO' },
    { id: '157', value: 'REPUBLICA DEL NIGER' },
    { id: '168', value: 'REPUBLICA DEL PERU' },
    { id: '208', value: 'REPUBLICA DEL SUDAN' },
    { id: '185', value: 'REPUBLICA DEL YEMEN' },
    { id: '259', value: 'REPUBLICA DEMOCRATICA DEL CONGO' },
    { id: '65', value: 'REPUBLICA DEMOCRATICA FEDERAL DE ETIOPIA' },
    { id: '12', value: 'REPUBLICA DEMOCRATICA POPULAR DE ARGELIA' },
    { id: '127', value: 'REPUBLICA DEMOCRATICA POPULAR DE LAOS' },
    { id: '206', value: 'REPUBLICA DEMOCRATICA SOCIALISTA DE SRI LANKA' },
    { id: '186', value: 'REPUBLICA DOMINICANA' },
    { id: '3', value: 'REPUBLICA FEDERAL DE ALEMANIA' },
    { id: '32', value: 'REPUBLICA FEDERAL DE BRASIL' },
    { id: '158', value: 'REPUBLICA FEDERAL DE NIGERIA' },
    { id: '1', value: 'REPUBLICA ISLAMICA DE AFGANISTAN' },
    { id: '95', value: 'REPUBLICA ISLAMICA DE IRAN' },
    { id: '146', value: 'REPUBLICA ISLAMICA DE MAURITANIA' },
    { id: '166', value: 'REPUBLICA ISLAMICA DE PAQUISTAN' },
    { id: '188', value: 'REPUBLICA ORIENTAL DE URUGUAY' },
    { id: '165', value: 'REPUBLICA PANAMA' },
    { id: '52', value: 'REPUBLICA POPULAR CHINA' },
    { id: '22', value: 'REPUBLICA POPULAR DE BANGLADESH' },
    { id: '42', value: 'REPUBLICA POPULAR DEMOCRATICA DE COREA' },
    { id: '229', value: 'REPUBLICA SOCIALISTA DE VIETNAM' },
    { id: '214', value: 'REPUBLICA UNIDA DE TANZANIA' },
    { id: '270', value: 'REUNION' },
    { id: '189', value: 'RODESIA' },
    { id: '191', value: 'RUMANIA' },
    { id: '193', value: 'SAHARA DEL OESTE' },
    { id: '237', value: 'SAMOA' },
    { id: '194', value: 'SAMOA AMERICANA' },
    { id: '235', value: 'SAN CRISTOBAL Y NIEVES' },
    { id: '196', value: 'SAN KITTS' },
    { id: '197', value: 'SAN VICENTE Y LAS GRANADINAS' },
    { id: '198', value: 'SANTA ELENA' },
    { id: '273', value: 'SANTA SEDE ESTADO DE LA CIUDAD DEL VATICANO' },
    { id: '253', value: 'SANTO TOME Y PRINCIPE' },
    { id: '0', value: 'SE DESCONOCE' },
    { id: '254', value: 'SERBIA' },
    { id: '200', value: 'SERENISIMA REPUBLICA DE SAN MARINO' },
    { id: '203', value: 'SLOVAKIA' },
    { id: '204', value: 'SLOVENIA' },
    { id: '205', value: 'SOMALIA' },
    { id: '252', value: 'SUAZILANDIA' },
    { id: '163', value: 'SULTANATO DE OMAN' },
    { id: '11', value: 'SVALBARD Y JAN MAYEN' },
    { id: '264', value: 'TERRITORIO BRITANICO DEL OCEANO INDICO' },
    { id: '271', value: 'TERRITORIOS AUSTRALES FRANCESES' },
    { id: '239', value: 'TERRITORIOS PALESTINOS' },
    { id: '217', value: 'TOKELAU' },
    { id: '218', value: 'TRIESTE' },
    { id: '220', value: 'TRISTAN DE CUNHA' },
    { id: '222', value: 'TURKMENISTAN' },
    { id: '224', value: 'TUVALU' },
    { id: '225', value: 'UCRANIA' },
    { id: '226', value: 'UGANDA' },
    { id: '234', value: 'UNION DE MYANMAR' },
    { id: '274', value: 'WALLIS Y FUTUNA' },
    { id: '255', value: 'ZIMBABUE' }
];
